import { useQuery } from '@tanstack/react-query';

import { prescreenEndpoints } from '@/modules/prescreen/constants';
import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { prescreenQueryKeys } from './queryKeys';

export const usePrescreenNameQuery = (candidateJobId: string) => {
  return useQuery({
    queryKey: prescreenQueryKeys.name(candidateJobId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(prescreenEndpoints.name, {
        params: { path: { candidateJobId } },
      });
      return data;
    },
    enabled: !!candidateJobId,
  });
};
